import { api } from "@/lib/apiClient";

export interface CountryOption {
  id: number;
  name: string;
}

export interface StateOption {
  id: number;
  countryId: number;
  name: string;
}

type CountryApiRecord = { id: number | string; name: string };
type StateApiRecord = { id: number | string; country_id: number | string; name: string };

function extractRows<T>(body: unknown): T[] {
  if (Array.isArray(body)) return body as T[];
  if (body && typeof body === "object") {
    const data = (body as Record<string, unknown>).data;
    if (Array.isArray(data)) return data as T[];
  }
  return [];
}

let countriesCache: CountryOption[] | null = null;
const statesCache = new Map<number, StateOption[]>();

export async function fetchCountries(): Promise<CountryOption[]> {
  if (countriesCache) return countriesCache;
  const response = await api.get("/api/v1/geo/countries");
  const rows = extractRows<CountryApiRecord>(response.data);
  countriesCache = rows.map((row) => ({ id: Number(row.id), name: row.name }));
  return countriesCache;
}

export async function fetchStates(countryId: number): Promise<StateOption[]> {
  if (!countryId) return [];
  const cached = statesCache.get(countryId);
  if (cached) return cached;
  const response = await api.get("/api/v1/geo/states", { params: { country_id: countryId } });
  const rows = extractRows<StateApiRecord>(response.data);
  const mapped = rows.map((row) => ({
    id: Number(row.id),
    countryId: Number(row.country_id),
    name: row.name,
  }));
  statesCache.set(countryId, mapped);
  return mapped;
}
